import { render, staticRenderFns } from "./tempMeninggalDunia.vue?vue&type=template&id=21d69fbc&"
import script from "./tempMeninggalDunia.vue?vue&type=script&lang=js&"
export * from "./tempMeninggalDunia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports